var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-page-new',{attrs:{"title":_vm.$t('Westudypartner'),"subtitle":_vm.$t('WestudyPartner'),"root":_vm.$t('Dashboard')},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('router-view')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }